import { useTranslation } from "react-i18next";
import AuthoringPage from "../AuthoringPage";
import SkillForm from "./SkillForm";

/** `/workflows/new/skill`: the form for a new skill. */
export default function NewSkillPage() {
  const { t } = useTranslation();
  return (
    <AuthoringPage title={t("authoring.skill.newTitle")} intro={t("authoring.skill.intro")}>
      {(projectId, options) => <SkillForm projectId={projectId} options={options} />}
    </AuthoringPage>
  );
}
